import { Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { UserProfileService } from 'src/app/component/user-profile/service/user-profile.service';
import { HelpTextService } from '../service/help-text.service';
import { LOGINDETAILS } from 'src/app/component/system/accounts/model/login-audit';
import { HelpText } from '../model/helpText.model';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { GetPropertyPipe } from 'src/app/pipes/get-property.pipe';
import { EditHelpTextComponent } from '../edit-help-text/edit-help-text.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';

@Component({
    selector: 'search-help-texts',
    templateUrl: './search-help-texts.component.html',
    styleUrl: './search-help-texts.component.scss'
})
export class SearchHelpTextsComponent implements OnInit {
    @ViewChildren(MatPaginator) paginators: QueryList<MatPaginator> = new QueryList<MatPaginator>();
    @ViewChildren(MatSort) sorts: QueryList<MatSort> = new QueryList<MatSort>();
    @ViewChild('res') resElement: ElementRef;

    user: LOGINDETAILS;

    helpTexts: HelpText[];

    // Table display
    displayedColumns: string[] = ['EDIT', 'modifiedDate', 'modifiedBy', 'id', 'routeUrls[0]'];
    pageSize: number = 10;

    // Table results
    tableDataSource!: MatTableDataSource<HelpText>;
    filter: string = '';

    promises: any[] = [];
    isLoading: boolean = true;
    isSaving: boolean = false;

    getPropertyPipe = new GetPropertyPipe();

    constructor(private dialog: MatDialog, public helpTextService: HelpTextService, private userProfileService: UserProfileService) {}

    ngOnInit(): void {
        this.isLoading = true;

        this.indexHelpTexts();
        this.getUserProfile();

        Promise.all(this.promises).then((res) => {
            this.updateDataSource();

            this.isLoading = false;
        });
    }

    indexHelpTexts() {
        let deferred = new Promise((resolve, reject) => {
            this.helpTextService.index().subscribe((res) => {
                if (res) {
                    this.helpTexts = res;

                    resolve(res);
                } else if (res?.msg) {
                    reject(res);
                } else {
                    reject('err');
                }
            });
        });
        this.promises.push(deferred);
    }

    getUserProfile() {
        let deferred = new Promise((resolve, reject) => {
            this.userProfileService.getMyProfile().subscribe((res) => {
                if (res?.user) {
                    this.user = res.user;

                    resolve(res);
                } else if (res?.msg) {
                    reject(res);
                } else {
                    reject('err');
                }
            });
        });
        this.promises.push(deferred);
    }

    updateDataSource() {
        setTimeout(() => {
            // Data
            this.tableDataSource = new MatTableDataSource<HelpText>();
            this.tableDataSource.data = this.helpTexts;

            // Paginator
            this.tableDataSource.paginator = this.paginators.toArray()[0];

            // Sort
            this.tableDataSource.sort = this.sorts.toArray()[0];
            const defaultSort: Sort = { active: 'id', direction: 'asc' };
            this.tableDataSource.sort.active = defaultSort.active;
            this.tableDataSource.sort.direction = defaultSort.direction;
            this.tableDataSource.sort.sortChange.emit(defaultSort);
            this.tableDataSource.sortingDataAccessor = (obj, property) => this.getPropertyPipe.transform(obj, property, true);

            // Filter
            this.tableDataSource.filterPredicate = (data: any, filter) => {
                const dataStr = JSON.stringify(data).toLowerCase();
                return dataStr.indexOf(filter) != -1;
            };
        });
    }

    setFilter() {
        this.tableDataSource.filter = this.filter.trim().toLocaleLowerCase();
    }

    announceSortChange(sortState: Sort) {}

    onPageChange(event: PageEvent) {
        setTimeout(() => {
            const targetElement = this.resElement.nativeElement;
            targetElement.scrollIntoView({ behavior: 'smooth' });
        }, 100);
    }

    openDialogEdit(helpText: HelpText) {
        let payload: any = {};
        payload.helpTextId = helpText.id;
        payload.helpText = helpText;

        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.data = payload;
        dialogConfig.maxHeight = '99vh';
        dialogConfig.minWidth = '50vw';
        const dialogRef = this.dialog.open(EditHelpTextComponent, dialogConfig);

        dialogRef.afterClosed().subscribe((res: any) => {
            if (res && res.helpText) {
                let foundIndex = this.helpTexts.findIndex((ht) => ht.id === res.helpText.id);
                if (foundIndex >= 0) {
                    this.helpTexts[foundIndex] = res.helpText;
                    this.tableDataSource.data = this.helpTexts;
                }
            }

            if (res && res.refresh) {
                let foundIndex = this.helpTexts.findIndex((ht) => ht.id === helpText.id);
                if (foundIndex >= 0) {
                    this.helpTexts.splice(foundIndex, 1);
                    this.tableDataSource.data = this.helpTexts;
                }
            }
        });
    }

    deleteHelpText(helpText: HelpText) {
        this.isSaving = true;
        this.helpTextService.deleteHelpTexts(helpText.id).subscribe((res) => {
            let foundIndex = this.helpTexts.findIndex((ht) => ht.id === helpText.id);
            if (foundIndex >= 0) {
                this.helpTexts.splice(foundIndex, 1);
                this.tableDataSource.data = this.helpTexts;
            }
        });
    }
}
